module.exports = __webpack_public_path__ + "img/icon-71.acbff0e5.png";